import React from 'react';
import PropTypes from 'prop-types';
import {withStyles} from '@material-ui/core/styles';
import Hidden from '@material-ui/core/Hidden';
import Emphasis from '../components/Emphasis';
import Typography from '../components/Typography';
import MembershipForm from './MembershipForm';
import {emphasisStyles} from '../helpers';

const styles = theme => ({
  root: {
    textAlign: 'center',
    marginTop: '1rem',
    padding: '3rem 1rem',
    backgroundColor: '#FFFFFF',
    borderRadius: 4,

  },
  callUs: {
    textDecoration: 'none',
    '&:hover': {
      color: theme.palette.secondary.main,
      textDecoration: 'underline'
    }
  }
});

class LeadFormContainer extends React.Component {
  render() {
    const {classes, heading, heading_continued = '', emphasis} = this.props;

    return (
      <div className={`${classes.root} padding-xs`}>
        <Typography bold={true} variant='subtitle1' color='text.secondary'>BECOME A MEMBER</Typography>
        <Typography variant='h2'>{heading}{emphasis && <Emphasis>{emphasis}</Emphasis>}{heading_continued}</Typography>
        <Typography bold={true} variant='subtitle2' color='secondary.dark'>30 Day Money-Back
          Guarantee</Typography>
        <div id="dbcom_lead_form">
          <MembershipForm showTerms={true} mustAgree={true}/>
        </div>
        <Typography className={classes.callUs} component='a' href="tel:+18447686945" bold={true} variant='subtitle2'
                    color='secondary.dark'>
          Questions? Call us at 1-844-768-6945
        </Typography>
      </div>
    );
  }
}

LeadFormContainer.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(LeadFormContainer);
